import { Component, OnInit, Input } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { URLS } from '../../constant/interface';
import { _HttpClient } from '@delon/theme';
import { apiPrefix } from '../../utils/constants';

type Theme = 'green' | 'cyan' | 'megenta' | 'volcano' | 'purple' | ' blue' | 'gray';

interface Target {
  [key: string]: any;
  /** 组id */
  groupId?: number;
  /** 组名称 */
  groupName?: string;
  /** 贴片应用类型 */
  method?: string | number;
  /** 贴片类型 */
  type?: number;
  /** 比例对象 */
  weightParam?: any;
}

interface Patch {
  [key: string]: any;
  /** 贴片内容 */
  content?: string;
  /** 贴片ID */
  id?: number;
  /** 贴片标题 */
  title?: string;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-patch-popover',
  templateUrl: './icc-patch-popover.component.html',
  styleUrls: ['./icc-patch-popover.component.less'],
})
export class IccPatchPopoverComponent implements OnInit {
  /** 主题 */
  @Input() theme: Theme = 'cyan';
  /** 贴片参数 */
  @Input() target: Target;

  /** 贴片列表 */
  patchList: Patch[] = [];
  /** 贴片方式 */
  method = '';
  /** 贴片组名称 */
  name = '';
  /** 媒体地址 */
  mediaUrl = apiPrefix + '/common/attachment/download' + '?';
  constructor(private http: _HttpClient, private dialogService: DialogService) {}

  ngOnInit() {
    const { groupId, method, type, weightParam, groupName, itemId } = this.target;
    this.name = groupName;
    // this.name = groupName.replace('_patch_', '');
    this.getPatchListByGroupId(groupId, type).subscribe(res => {
      if (res.status === 0) {
        this.patchList = itemId ? res.data.filter(v => v.id === itemId) : res.data;
        this.processMethods(Number(method));
        this.processPatch(Number(method), weightParam);
      } else {
        this.dialogService.notification.error('贴片展示', '获取贴片失败');
      }
    });
  }
  /** 处理贴片方式 */
  private processMethods(method: number) {
    let tip = '';
    switch (method) {
      case 1:
        tip = '指定贴片';
        break;
      case 2:
        tip = '随机贴片';
        break;
      case 3:
        tip = '比例贴片';
        break;
      default:
        break;
    }
    this.method = tip;
  }
  /** 贴片内部处理 */
  private processPatch(method: number, weightParam: any) {
    if (method === 3) {
      for (let patch of this.patchList) {
        if (weightParam[patch.id]) patch.rate = weightParam[patch.id] || 0;
      }
    }
  }

  /** 根据贴片组id获取全部贴片 */
  private getPatchListByGroupId(id, type) {
    return this.http.post(URLS.templatePatchGroupItem.url, { id, type });
  }
}
